import React from 'react';
import { MessageCircle } from 'lucide-react';

const LicenseSection = () => {
  return (
    <section style={{
      padding: '80px 20px',
      background: 'linear-gradient(180deg, #0f0a1e 0%, #1a0e2e 100%)',
    }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '12px' }}>
          <span style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '28px',
            fontWeight: 700,
          }}>
            <span style={{ color: '#00d4ff' }}>Inner</span>{' '}
            <span style={{ color: '#ffd700' }}>Bridge</span>
          </span>
        </div>
        <p style={{
          textAlign: 'center',
          fontSize: '13px',
          letterSpacing: '3px',
          color: '#8885a0',
          textTransform: 'uppercase',
          marginBottom: '40px',
        }}>
          The Quantum Spiritual Academy
        </p>

        {/* License Info Card */}
        <div
          className="glass-card license-card"
          style={{
            marginBottom: '50px',
          }}
        >
          <div className="grid-license">
            {/* English */}
            <div>
              <h4 style={{ fontSize: '18px', fontWeight: 700, marginBottom: '4px', color: '#ffffff' }}>
                The Inner Bridge
              </h4>
              <p style={{ fontSize: '13px', color: '#8885a0', marginBottom: '16px' }}>
                Innovation Lifestyle Consultancy L.L.C-FZ
              </p>
              <p style={{ fontSize: '14px', color: '#b0adc0', marginBottom: '6px' }}>
                <span style={{ color: '#00d4ff', fontWeight: 600 }}>License Number:</span> 2646553.01
              </p>
              <p style={{ fontSize: '14px', color: '#b0adc0', marginBottom: '6px' }}>
                <span style={{ color: '#00d4ff', fontWeight: 600 }}>Formation Number:</span> 2646553
              </p>
              <p style={{ fontSize: '14px', color: '#b0adc0' }}>
                <span style={{ color: '#00d4ff', fontWeight: 600 }}>Address:</span> Meydan Grandstand, 6th Floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E.
              </p>
            </div>
            {/* Arabic */}
            <div style={{ textAlign: 'right', direction: 'rtl' }}>
              <h4 style={{ fontSize: '18px', fontWeight: 700, marginBottom: '4px', color: '#ffffff' }}>
                The Inner Bridge شركة
              </h4>
              <p style={{ fontSize: '13px', color: '#8885a0', marginBottom: '16px' }}>
                Innovation Lifestyle Consultancy L.L.C-FZ
              </p>
              <p style={{ fontSize: '14px', color: '#b0adc0', marginBottom: '6px' }}>
                <span style={{ color: '#00d4ff', fontWeight: 600 }}>رقم الرخصة:</span> 2646553.01
              </p>
              <p style={{ fontSize: '14px', color: '#b0adc0', marginBottom: '6px' }}>
                <span style={{ color: '#00d4ff', fontWeight: 600 }}>رقم التأسيس:</span> 2646553
              </p>
              <p style={{ fontSize: '14px', color: '#b0adc0' }}>
                <span style={{ color: '#00d4ff', fontWeight: 600 }}>العنوان:</span> ميدان جراند ستاند، الطابق السادس، شارع الميدان، ند الشبا مدينة دبي، الإمارات العربية المتحدة
              </p>
            </div>
          </div>
        </div>

        {/* WhatsApp Contact */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <p style={{ fontSize: '15px', color: '#b0adc0', marginBottom: '4px' }}>
            للتواصل والاستفسار
          </p>
          <p style={{ fontSize: '15px', color: '#b0adc0', marginBottom: '16px' }}>
            على رقم الوتس-آب
          </p>
          <a
            href="https://wa.me/963988242654"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              background: '#25d366',
              color: 'white',
              padding: '14px 36px',
              borderRadius: '30px',
              fontSize: '18px',
              fontWeight: 700,
              textDecoration: 'none',
              boxShadow: '0 4px 20px rgba(37, 211, 102, 0.3)',
              marginBottom: '16px',
            }}
          >
            <MessageCircle size={22} />
            +963 988 242 654
          </a>
          <p style={{ fontSize: '14px', color: '#8885a0', marginBottom: '4px' }}>
            مدير قسم البرمجة والذكاء الاصطناعي
          </p>
          <p style={{ fontSize: '16px', color: '#00d4ff', fontWeight: 600 }}>
            كنان واكد
          </p>
        </div>

        {/* WhatsApp Customer Service Numbers */}
        <div style={{ textAlign: 'center', marginBottom: '20px', marginTop: '48px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 28 }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#25d366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            <h3 style={{
              fontSize: 18,
              fontWeight: 700,
              color: '#25d366',
              fontFamily: 'Inter, sans-serif',
              direction: 'rtl',
            }}>
              أرقام خدمة العملاء - واتس آب
            </h3>
          </div>

          <div className="grid-whatsapp">
            {[
              { region: 'الأمريكيتين', number: '+17808627900' },
              { region: 'أوروبا', number: '+33660716479' },
              { region: 'دمشق', number: '+963933492642' },
              { region: 'دول الخليج', number: '+966558604875' },
            ].map((item) => (
              <a
                key={item.number}
                href={`https://wa.me/${item.number.replace(/\+/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: 'rgba(37, 211, 102, 0.06)',
                  border: '1px solid rgba(37, 211, 102, 0.2)',
                  borderRadius: 14,
                  padding: '20px 14px',
                  textDecoration: 'none',
                  textAlign: 'center',
                  transition: 'border-color 0.2s, background 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = 'rgba(37, 211, 102, 0.5)';
                  e.currentTarget.style.background = 'rgba(37, 211, 102, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'rgba(37, 211, 102, 0.2)';
                  e.currentTarget.style.background = 'rgba(37, 211, 102, 0.06)';
                }}
              >
                <p style={{ fontSize: 14, color: '#25d366', fontWeight: 600, marginBottom: 8, direction: 'rtl' }}>
                  {item.region}
                </p>
                <p style={{ fontSize: 16, color: '#e0dff0', fontWeight: 700, direction: 'ltr' }}>
                  {item.number}
                </p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LicenseSection;
